import { RecordFolderAssignment } from '@provision/entity-types';
import { useMutation } from '@provision/graphql-client';
import { useCallback } from 'react';
import { DELETE_RECORD_FOLDER_ASSIGNMENT_QUERY } from 'src/graphql/entities/record-folder-assignment/record-folder-assignment.operations';

export interface DeleteRecordFolderAssignment {
  deleteRecordFolderAssignment: Pick<RecordFolderAssignment, 'id'>[];
}

interface DeleteRecordFolderAssignmentOptions {
  omitIsolationModeHeader?: boolean;
}

export const useDeleteRecordFolderAssignment = () => {
  const [deleteRecordFolderAssignment, { loading: isLoading }] =
    useMutation<DeleteRecordFolderAssignment>(DELETE_RECORD_FOLDER_ASSIGNMENT_QUERY, {
      update(cache, { data }) {
        if (!data?.deleteRecordFolderAssignment?.length) return;

        const id = cache.identify({
          __typename: 'RecordFolderAssignment',
          id: data.deleteRecordFolderAssignment[0].id,
        });

        cache.evict({ id });
        cache.gc();
      },
    });

  const deleteWithOptimisticResponse = useCallback(
    async (
      recordFolderAssignment: RecordFolderAssignment,
      options?: DeleteRecordFolderAssignmentOptions,
    ) => {
      await deleteRecordFolderAssignment({
        variables: {
          recordFolderAssignmentId: recordFolderAssignment.id,
        },
        optimisticResponse: {
          deleteRecordFolderAssignment: [recordFolderAssignment],
        },
        context: options?.omitIsolationModeHeader
          ? { omitIsolationModeHeader: true }
          : undefined,
      });
    },
    [deleteRecordFolderAssignment],
  );

  return {
    deleteRecordFolderAssignment: deleteWithOptimisticResponse,
    isLoading,
  };
};
